export const getAmexErrorsFromAmexGatewayValidationError = (serverError) => {
    var _a;
    let parsedServerError = (_a = JSON.parse(serverError)) === null || _a === void 0 ? void 0 : _a.data;
    if (!parsedServerError) {
        parsedServerError = JSON.parse(serverError);
    }
    if (parsedServerError.errors) {
        const errors = [];
        parsedServerError === null || parsedServerError === void 0 ? void 0 : parsedServerError.errors.forEach((error) => {
            error === null || error === void 0 ? void 0 : error.cardUserErrors.forEach((cardError) => {
                cardError === null || cardError === void 0 ? void 0 : cardError.errors.forEach((err) => {
                    errors.push(err);
                });
            });
        });
        if (errors.length) {
            return errors;
        }
    }
    return null;
};
